import { CircleAlert } from "lucide-react";

export const InlineError = ({
  id,
  message,
}: {
  id?: string;
  message: string | null;
}) => {
  if (!message) {
    return null;
  }
  return (
    <p
      className="m-0 flex items-start gap-2 text-error text-sm leading-[1.45]"
      id={id}
      role="alert"
    >
      <CircleAlert
        aria-hidden
        className="mt-0.5 shrink-0"
        size={16}
        strokeWidth={1.75}
      />
      <span>{message}</span>
    </p>
  );
};
